import { render, staticRenderFns } from "./TosMess.vue?vue&type=template&id=9332bee2&scoped=true&"
import script from "./TosMess.vue?vue&type=script&lang=js&"
export * from "./TosMess.vue?vue&type=script&lang=js&"
import style0 from "./TosMess.vue?vue&type=style&index=0&id=9332bee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9332bee2",
  null
  
)

export default component.exports